import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {PropsWithChildren} from 'react'
import {TicketsListContainerProps} from './interfaces'
import s from './tickets-list-container.scss'

export const TicketsListContainer = ({
  chooseSeatMode,
  chooseMultipleSeatsMode,
  children,
  className,
  basketView,
}: PropsWithChildren<TicketsListContainerProps>) => {
  const {isMobile} = useEnvironment()
  const {experiments} = useExperiments()
  const planTicketsDesignEnabled = experiments.enabled(ExperimentNames.PlanTicketsDesign)

  return (
    <ul
      className={classNames(s.list, className, {
        [s.basketViewDesktop]: basketView && !isMobile,
        [s.mobileList]: isMobile,
        [s.listPaddingTop]: chooseSeatMode || chooseMultipleSeatsMode,
        [s.newListGap]: planTicketsDesignEnabled,
      })}
    >
      {children}
    </ul>
  )
}
